import React, { useCallback } from 'react';
import { Input, InputGroup, InputRightElement } from '@chakra-ui/react';

import { withConfirm } from '../withConfirm';
import { CustomFormControl, DirectionProp } from '../CustomFormControl';

interface IProps extends DirectionProp {
  id?: string;
  name?: string;
  value?: string | number;
  label?: string;
  subText?: string;
  type?: string;
  inputHelperText?: string;
  errorText?: string;
  forwardedRef?: ((instance: HTMLInputElement | null) => void) | React.RefObject<HTMLInputElement> | null | undefined;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  size?: 'lg' | 'md' | 'sm';
  mb?: number | string;
}

const PercentageInput: React.FC<IProps> = (props: IProps) => {
  const {
    id,
    name,
    label,
    value,
    type,
    subText,
    errorText,
    onChange,
    forwardedRef,
    onBlur,
    onFocus,
    size = 'lg',
    mb = 0,
    direction
  } = props;
  const dataId = id || 'default';

  const onInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.currentTarget.value || '';
      // allow max '100' value
      if (value.length >= 3 && value !== '100') return;
      onChange && onChange(event);
    },
    [onChange]
  );

  return (
    <CustomFormControl
      id={dataId}
      controlProps={{
        isInvalid: errorText ? true : false,
        mb: mb
      }}
      direction={direction}
      size={size}
      label={label}
      subLabel={subText}
      error={errorText}
    >
      <InputGroup data-selector="input-wrapper" size={size}>
        <Input
          data-selector="input-field"
          name={name}
          onChange={onInputChange}
          type={type}
          value={value || ''}
          ref={forwardedRef}
          pattern="\d*"
          inputMode="numeric"
          maxLength={3}
          onBlur={onBlur}
          onFocus={onFocus}
        />

        <InputRightElement pointerEvents="none">%</InputRightElement>
      </InputGroup>
    </CustomFormControl>
  );
};

const PercentageInputWithConfirm = withConfirm(PercentageInput);

export { PercentageInput, PercentageInputWithConfirm };
